import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, PageEvent, MatPaginator, MatDialog } from '@angular/material';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ComponentPageTitle } from 'src/app/page-title/page-title.component';
import { AppServiceService } from 'src/app/services/app-service.service';
import { BusquedaService } from '../busqueda.service';
import { CreateService } from '../createservice';
import { GatewayService } from 'src/app/gateway.service';
import { FiltroPaisService } from '../filtro-pais.service';
import { LocalSaveService } from 'src/app/services/local-save-service.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatSnackBar } from '@angular/material';
import { FormGroup, FormControl } from '@angular/forms';
import { VerCertificadoDialogComponent } from './ver-certificado-dialog/ver-certificado-dialog.component';
import { DescargarLotesComponent } from 'src/app/home/descargar-lotes/descargar-lotes.component';

@Component({
  selector: 'app-historialcertificado',
  templateUrl: './historialcertificado.component.html',
  styleUrls: ['./historialcertificado.component.scss']
})
export class HistorialcertificadoComponent implements OnInit {
  private destroy$ = new Subject<void>();
  minDate = new Date();
  maxDate = new Date();

  grupoVal = new FormGroup({
    FECHA_EJECUCION: new FormControl(''),
    ORDEN: new FormControl(''),
    IDUSER: new FormControl(''),
    EQUIPO: new FormControl(''),
  });

  tableColumns: string[] = ['ID', 'EQUIPO', 'TIPO', 'IDUSER', 'NOMBRE_USUARIO', 'TIPO_USER', 'FECHA_EJECUCION', 'ID_CITA', 'ORDEN', 'STATUS_CERTIFICADO', 'ACCIONES'];
  dataSource = new MatTableDataSource<any>([]);
  private subscriptioncreate: Subscription;
  private subscriptionpais: Subscription;
  FILTER: string = '';
  resultsLength = 0;
  pageSize = 10;
  idpais: any;
  pageEvent: PageEvent;
  public actpage: number = 0;
  public listaUsuarios: any[] = [];
  @ViewChild('paginatortable') paginatortable: MatPaginator;

  constructor(
    private spinner: NgxSpinnerService,
    private gateway: GatewayService,
    public pageTitle: ComponentPageTitle,
    public _appservice: AppServiceService,
    public _busqueda: BusquedaService,
    public _create: CreateService,
    private dialog: MatDialog,
    public _filtroPais: FiltroPaisService,
    private localSave: LocalSaveService,
    private snackbar: MatSnackBar
  ) { }

  ngOnInit() {
    this.idpais = this.localSave.get('pais');
    
    const usuario = this.localSave.get('usuarioPGV');
    if (usuario) {
      const idrol = usuario.idrol || usuario.IDROL;
      if (idrol == 17) {
        this.pageSize = 6;
      } else if (idrol == 25) {
        this.pageSize = 10;
      } else {
        this.pageSize = 10;
      }
    }
    
    this.cargarUsuarios();
    
    this.get(0);
    this.pageTitle.title = 'Historial de Certificados';
    
    this.subscriptioncreate = this._create.notifyObservable$.pipe(takeUntil(this.destroy$)).subscribe(
      res => {
      });
    this.subscriptionpais = this._filtroPais.notifyObservable$.pipe(takeUntil(this.destroy$)).subscribe(
      res => {
        this.idpais = res.IDPAIS;
        this.get(0);
      }
    );
  }

  public filtrogeneral() {
    if (this.paginatortable) {
      this.paginatortable.firstPage();
    }
    this.get(0);
  }

  public descargar() {
    const fechaEjecucion = this.formatDateToYYYYMMDD(this.grupoVal.controls.FECHA_EJECUCION.value);

    const dialogRef = this.dialog.open(DescargarLotesComponent, {
      disableClose: true,
      width: '700px',
      data: {
        cantPorPagina: 1000,
        nombreServicioCantRegistros: 'getContHistorialCertificado',
        nombreServicioRegistros: 'descargarHistorialCertificado',
        nombreArchivo: `historial_certificados_${new Date().toISOString().slice(0, 10).replace(/-/g, '')}.xlsx`,
        params: {
          FECHA_EJECUCION: fechaEjecucion,
          ORDEN: this.grupoVal.controls.ORDEN.value || '',
          IDUSER: this.grupoVal.controls.IDUSER.value || '',
          EQUIPO: this.grupoVal.controls.EQUIPO.value || ''
        }
      }
    });

    dialogRef.afterClosed().subscribe((resp) => {
    });
  }

  cargarUsuarios() {
    this.gateway.get('getUsuariosCertificado', {}).then((result: any) => {
      this.listaUsuarios = (result.rows || []).filter(usuario => 
        usuario.NOMBRE_USUARIO && 
        usuario.NOMBRE_USUARIO.trim() !== ''
      );
    }).catch((e) => {
      this.listaUsuarios = [];
    });
  }

  private formatDateToYYYYMMDD(date: any): string {
    if (!date) {
      return '';
    }
    const d = new Date(date);
    if (isNaN(d.getTime())) {
      return '';
    }
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  get(page) {
    this.spinner.show();
    const fechaEjecucion = this.formatDateToYYYYMMDD(this.grupoVal.controls.FECHA_EJECUCION.value);
    
    this.gateway.get('getHistorialCertificado',
      {
        NUM_ELEMENTOS: this.pageSize,
        NUM_PAGINA: page,
        FECHA_EJECUCION: fechaEjecucion,
        ORDEN: this.grupoVal.controls.ORDEN.value || '',
        IDUSER: this.grupoVal.controls.IDUSER.value || '',
        EQUIPO: this.grupoVal.controls.EQUIPO.value || ''
      }).then((result) => {
        let aux: any = result;
        let rows = aux.rows || [];
        
        this.dataSource = new MatTableDataSource<any>(rows);

        const fechaEjecucionCount = this.formatDateToYYYYMMDD(this.grupoVal.controls.FECHA_EJECUCION.value);
        
        this.gateway.get('getContHistorialCertificado', {
          NUM_ELEMENTOS: this.pageSize,
          NUM_PAGINA: page,
          FECHA_EJECUCION: fechaEjecucionCount,
          ORDEN: this.grupoVal.controls.ORDEN.value || '',
          IDUSER: this.grupoVal.controls.IDUSER.value || '',
          EQUIPO: this.grupoVal.controls.EQUIPO.value || ''
        }).then((result: any) => {
          this.resultsLength = result.rows && result.rows.length > 0 ? result.rows[0].total : 0;
          this.spinner.hide();
        }).catch((e) => {
          this.resultsLength = 0;
          this.spinner.hide();
        });
      }
      ).catch((e) => {
        this.dataSource = new MatTableDataSource<any>([]);
        this.resultsLength = 0;
        this.spinner.hide();
      });
  }

  cambioElementos(event?: PageEvent) {
    this.actpage = event.pageIndex;
    this.get(event.pageIndex);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    if (this.subscriptioncreate) {
      this.subscriptioncreate.unsubscribe();
    }
    if (this.subscriptionpais) {
      this.subscriptionpais.unsubscribe();
    }
  }

  copyToClipboard(data: any) {
    let jsonString: string;
    
    try {
      if (typeof data === 'string') {
        const parsed = JSON.parse(data);
        jsonString = JSON.stringify(parsed, null, 2);
      } else {
        jsonString = JSON.stringify(data, null, 2);
      }
    } catch (e) {
      jsonString = typeof data === 'string' ? data : JSON.stringify(data);
    }
    
    const textArea = document.createElement('textarea');
    textArea.value = jsonString;
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    textArea.style.top = '-999999px';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    
    try {
      document.execCommand('copy');
      this.snackbar.open('JSON copiado al portapapeles', 'Cerrar', {
        duration: 2000,
        horizontalPosition: 'center',
        verticalPosition: 'bottom'
      });
    } catch (err) {
      this.snackbar.open('Error al copiar al portapapeles', 'Cerrar', {
        duration: 2000
      });
    } finally {
      document.body.removeChild(textArea);
    }
  }

  getFormattedJson(data: any): string {
    try {
      if (typeof data === 'string') {
        const parsed = JSON.parse(data);
        return JSON.stringify(parsed, null, 2);
      }
      return JSON.stringify(data, null, 2);
    } catch (e) {
      return typeof data === 'string' ? data : JSON.stringify(data);
    }
  }

  getJsonPreview(data: any): string {
    try {
      const jsonString = typeof data === 'string' ? data : JSON.stringify(data);
      return jsonString.length > 50 ? jsonString.substring(0, 50) + '...' : jsonString;
    } catch (e) {
      return 'Error al formatear JSON';
    }
  }

  verCertificado(element: any) {
    this.dialog.open(VerCertificadoDialogComponent, {
      width: '800px',
      maxWidth: '90vw',
      data: element
    });
  }

  aprobarCertificado(element: any) {
    // TODO: Implementar lógica para aprobar el certificado
  }
}
